export default __webpack_public_path__ + "static/media/Goto.6c9dbad5.svg";